<template>

  <div
    class="d-flex flex-column align-items-center justify-content-center text-center text-muted h-100"
    :class="slim ? 'py-3' : 'p-4'">
    <i
      class="fa-regular fa-comment-dots"
      :class="{ 'fa-2x mb-2': !slim }"></i>
    <p
      v-if="!slim"
      class="mb-0">{{ $t('No conversations') }}</p>
  </div>

</template>

<script>
export default {
  name: 'ConversationListEmpty',
  props: {
    slim: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Messaging/sidebar/ConversationListEmpty.vue